export class FlowQueryModel {
  category: string = "";
  searchString: string = "";
  userEmail: string = "";
  otherUserEmail: string = "";
  pageIndex: number = 0;
  partitionKey: string = "";
  rowKey: string = "";
  FlowId: string = "";
  customerId: string = "";
  BundleId: string = "";
  ContentType: string = "";
  FlowType: string = "";
  accessType: string = "";
  SearchDateTime: Date;
  includeUserContent: boolean = true;
  contentCreationPlanOnly: boolean = false;
  /** "Organization" or "Personal"; limits results to that account's content. */
  accountScope?: string;
  organizationId?: string;
  /** True on public profile listings; organization content is excluded. */
  publicProfileView?: boolean;
  constructor(data?: Partial<FlowQueryModel>) {
    if (data) {
      Object.assign(this, data);
    }
  }
}

export class UserQueryModel {
  category: string = "";
  searchString: string = "";
  userEmail: string = "";
  otherUserEmail: string = "";
  pageIndex: number = 0;
  FlowId: string = "";
  customerId: string = "";
  BundleId: string = "";
  Status: string = "";
  constructor(data?: Partial<UserQueryModel>) {
    if (data) {
      Object.assign(this, data);
    }
  }
}
